// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- HS Code
import { LogLevels } from '../../../models';
import { environment } from '../../../../environments/environment';

// #endregion

@Injectable()
export class LoggerService {
  constructor() {}

  logError(message: any, ...args: any[]) {
    if (this.loggingIsTurnedOff()) {
      return;
    }

    if (!!args && args.length) {
      console.error(message, ...args);
    } else {
      console.error(message);
    }
  }

  logWarning(message: any, ...args: any[]) {
    if (!this.logLevelIsSet()) {
      return;
    }

    if (this.loggingIsTurnedOff()) {
      return;
    }

    if (!this.currentLogLevelIsEqualOrSmallerThan(LogLevels.WARN)) {
      return;
    }

    if (!!args && args.length) {
      console.warn(message, ...args);
    } else {
      console.warn(message);
    }
  }

  logDebug(message: any, ...args: any[]) {
    if (!this.logLevelIsSet()) {
      return;
    }

    if (this.loggingIsTurnedOff()) {
      return;
    }

    if (!this.currentLogLevelIsEqualOrSmallerThan(LogLevels.DEBUG)) {
      return;
    }

    if (!!args && args.length) {
      console.log(message, ...args);
    } else {
      console.log(message);
    }
  }

  private currentLogLevelIsEqualOrSmallerThan(logLevel: LogLevels) {
    return environment.authSettings.authLogger.level <= logLevel;
  }

  private logLevelIsSet(): boolean {
    return !!(environment?.authSettings?.authLogger?.level >= LogLevels.NONE);
  }

  private loggingIsTurnedOff() {
    return environment?.authSettings?.authLogger?.level === LogLevels.NONE;
  }
}
